import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';

const Layout: React.FC = () => {
  const location = useLocation();

  return (
    <div className="relative h-dvh bg-gray-50 overflow-hidden">
      {/* Tessellating background pattern - show on all pages */}
      <div className="absolute opacity-10 pointer-events-none overflow-hidden" style={{ left: '-10%', top: '-10%', width: '120%', height: '120%' }}>
        {/* Generate seamless grid with extended coverage and subtle variations */}
        {Array.from({ length: 13 }, (_, row) =>
          Array.from({ length: 7 }, (_, col) => {
            const index = row * 7 + col;
            // Add subtle height variations to each element
            const heightOffset = (index * 17) % 7 - 3; // Random-ish offset between -3 and +3
            const scaleVariation = 0.6 + (index * 23) % 40 / 100; // Scale between 0.6 and 1.0
            return (
              <div
                key={index}
                className="absolute w-24 h-24"
                style={{
                  backgroundImage: 'url(/sam-lifting-cutout.png)',
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  left: `${col * 18 + (row % 2) * 9}%`, // Tighter 18% spacing with brick offset
                  top: `${row * 10 + heightOffset}%`, // 10% row spacing (compressed) + subtle height variation
                  transform: `rotate(${index * 41}deg) scale(${scaleVariation})`,
                  transformOrigin: 'center',
                }}
              />
            );
          })
        )}
      </div>
      
      <main className="relative z-10 h-full p-4 pb-20 overflow-y-auto">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 z-20 bg-white border-t p-1">
        <div className="flex justify-around">
          <Link
            to="/routines"
            className={`p-2 rounded flex flex-col items-center ${
              location.pathname === '/' || location.pathname.startsWith('/routines')
                ? 'bg-blue-100 text-blue-600' 
                : 'text-gray-600'
            }`}
          >
            <span className="text-lg mb-1">🏋️‍♂️</span>
            <span className="text-xs">Training</span>
          </Link>
          <Link
            to="/training-days"
            className={`p-2 rounded flex flex-col items-center ${
              location.pathname.startsWith('/training-days')
                ? 'bg-blue-100 text-blue-600' 
                : 'text-gray-600'
            }`}
          >
            <span className="text-lg mb-1">🗓️</span>
            <span className="text-xs">Workouts</span>
          </Link>
          <Link
            to="/exercises"
            className={`p-2 rounded flex flex-col items-center ${
              location.pathname.startsWith('/exercises')
                ? 'bg-blue-100 text-blue-600' 
                : 'text-gray-600'
            }`}
          >
            <span className="text-lg mb-1">💪</span>
            <span className="text-xs">Exercises</span>
          </Link>
          <Link
            to="/progress"
            className={`p-2 rounded flex flex-col items-center ${
              location.pathname.startsWith('/progress')
                ? 'bg-blue-100 text-blue-600' 
                : 'text-gray-600'
            }`}
          >
            <span className="text-lg mb-1">📊</span>
            <span className="text-xs">History</span>
          </Link>
        </div>
      </nav>
    </div>
  );
};

export default Layout;